module.exports = __webpack_public_path__ + "img/edit.1c67ad74.svg";